export default "__VITE_ASSET__n8xV5WWm__"